import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-121">
          ⛏️ MEGAPACK ESPECIALIZACIONES MINERAS™
        </h3>
        <p className="mb-2" data-id="element-122">
          El sistema de capacitación minera profesional N°1 en Argentina.
        </p>
        <p className="mb-8 italic" data-id="element-123">
          Especializate más. Ganás más. Vivís mejor.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-124">
          <p className="mb-4" data-id="element-125">© 2025 MEGAPACK MINERO™ — Guía Digital 360</p>
          <div className="flex justify-center gap-4" data-id="element-126">
            <a href="#" className="hover:text-white transition-colors" data-id="element-127">
              Privacidad
            </a>
            <span data-id="element-128">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-129">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}